module.exports = __webpack_public_path__ + "i18n/fr.020a13c56b8a41c1f5ac354c879c4f38.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 849
// module chunks = 60